"use client";

import dynamic from "next/dynamic";

const CookieBanner = dynamic(() => import("@/src/components/CookieBanner/CookieBanner"), {
  ssr: false,
});
const ChatbotEmbed = dynamic(() => import("@/src/components/ChatbotEmbed/ChatbotEmbed"), {
  ssr: false,
});

export function DeferredPublicWidgets() {
  return (
    <>
      <ChatbotEmbed />
      <CookieBanner />
    </>
  );
}
